import React from 'react';
import Responsive from 'react-responsive';
import { OLD_MOBILE_BREAKPOINT_MAX } from '../../../config/consts';

const Desktop = props => <Responsive {...props} minWidth={OLD_MOBILE_BREAKPOINT_MAX + 1} />;

export default Desktop;
